import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "LanguageSelectorButton" })
export default class LanguageSelectorButton extends Vue {
    public localizer: any = Localizer;
    public regionLabel: any = null;

    @Prop() readonly region: string;
    @Prop() readonly language: string;

    get isVisible(): any {
        return this.$store.getters["languageSelectorStore/isVisible"];
    }

    public created() {
        switch (this.region) {
            case "cz":
                this.regionLabel = this.localizer.get("App.Language.CzechRepublic");
                break;
            case "hu":
                this.regionLabel = this.localizer.get("App.Language.Hungary");
                break;
            case "pl":
                this.regionLabel = this.localizer.get("App.Language.Poland");
                break;
            case "de":
                this.regionLabel = this.localizer.get("App.Language.Germany");
                break;
            default:
                this.regionLabel = this.localizer.get("App.Language.Global");
                break;
        }
    }

    public openDialogue() {
        this.$store.commit("languageSelectorStore/setVisible", true);

        document.body.classList.add("overflow");
    }
};